import React from "react";
import { Card, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

export default function EmptyMessage({
  text = "If you had results, they'd appear here.",
  title = "No results",
}) {
  const { t } = useTranslation();

  const translatedTitle = title === "No results" ? t("no_results") : title;
  const translatedText =
    text === "If you had results, they'd appear here."
      ? t("if_you_had_results_they_d_appear_here")
      : text;
  return (
    <Card>
      <Text fw={700}>{translatedTitle}</Text>
      {/* <Text size="sm" variant="subtle">
        {text}
      </Text> */}
    </Card>
  );
}
